export const nounsDoaLogicAbi = [
  { inputs: [], name: "AdminOnly", type: "error" },
  { inputs: [], name: "CanOnlyInitializeOnce", type: "error" },
  { inputs: [], name: "InvalidNounsAddress", type: "error" },
  { inputs: [], name: "InvalidTimelockAddress", type: "error" },
  { inputs: [], name: "MustProvideActions", type: "error" },
  { inputs: [], name: "ProposalInfoArityMismatch", type: "error" },
  { inputs: [], name: "ProposerAlreadyHasALiveProposal", type: "error" },
  { inputs: [], name: "TooManyActions", type: "error" },
  { inputs: [], name: "UnsafeUint16Cast", type: "error" },
  { inputs: [], name: "VotesBelowProposalThreshold", type: "error" },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "numTokens", type: "uint256" },
      { indexed: false, internalType: "address", name: "to", type: "address" },
    ],
    name: "DAONounsSupplyIncreasedFromEscrow",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
      { indexed: false, internalType: "address", name: "to", type: "address" },
    ],
    name: "DAOWithdrawNounsFromEscrow",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address[]", name: "oldErc20Tokens", type: "address[]" },
      { indexed: false, internalType: "address[]", name: "newErc20tokens", type: "address[]" },
    ],
    name: "ERC20TokensToIncludeInForkSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint32", name: "forkId", type: "uint32" },
      { indexed: true, internalType: "address", name: "owner", type: "address" },
      { indexed: false, internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
      { indexed: false, internalType: "uint256[]", name: "proposalIds", type: "uint256[]" },
      { indexed: false, internalType: "string", name: "reason", type: "string" },
    ],
    name: "EscrowedToFork",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint32", name: "forkId", type: "uint32" },
      { indexed: false, internalType: "address", name: "forkTreasury", type: "address" },
      { indexed: false, internalType: "address", name: "forkToken", type: "address" },
      { indexed: false, internalType: "uint256", name: "forkEndTimestamp", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "tokensInEscrow", type: "uint256" },
    ],
    name: "ExecuteFork",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "oldForkDAODeployer", type: "address" },
      { indexed: false, internalType: "address", name: "newForkDAODeployer", type: "address" },
    ],
    name: "ForkDAODeployerSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "oldForkPeriod", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "newForkPeriod", type: "uint256" },
    ],
    name: "ForkPeriodSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "oldForkThreshold", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "newForkThreshold", type: "uint256" },
    ],
    name: "ForkThresholdSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint32", name: "forkId", type: "uint32" },
      { indexed: true, internalType: "address", name: "owner", type: "address" },
      { indexed: false, internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
      { indexed: false, internalType: "uint256[]", name: "proposalIds", type: "uint256[]" },
      { indexed: false, internalType: "string", name: "reason", type: "string" },
    ],
    name: "JoinFork",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint32", name: "oldLastMinuteWindowInBlocks", type: "uint32" },
      { indexed: false, internalType: "uint32", name: "newLastMinuteWindowInBlocks", type: "uint32" },
    ],
    name: "LastMinuteWindowSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint16", name: "oldMaxQuorumVotesBPS", type: "uint16" },
      { indexed: false, internalType: "uint16", name: "newMaxQuorumVotesBPS", type: "uint16" },
    ],
    name: "MaxQuorumVotesBPSSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint16", name: "oldMinQuorumVotesBPS", type: "uint16" },
      { indexed: false, internalType: "uint16", name: "newMinQuorumVotesBPS", type: "uint16" },
    ],
    name: "MinQuorumVotesBPSSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "oldAdmin", type: "address" },
      { indexed: false, internalType: "address", name: "newAdmin", type: "address" },
    ],
    name: "NewAdmin",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "oldPendingAdmin", type: "address" },
      { indexed: false, internalType: "address", name: "newPendingAdmin", type: "address" },
    ],
    name: "NewPendingAdmin",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "oldPendingVetoer", type: "address" },
      { indexed: false, internalType: "address", name: "newPendingVetoer", type: "address" },
    ],
    name: "NewPendingVetoer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "oldVetoer", type: "address" },
      { indexed: false, internalType: "address", name: "newVetoer", type: "address" },
    ],
    name: "NewVetoer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint32", name: "oldObjectionPeriodDurationInBlocks", type: "uint32" },
      { indexed: false, internalType: "uint32", name: "newObjectionPeriodDurationInBlocks", type: "uint32" },
    ],
    name: "ObjectionPeriodDurationSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "uint256", name: "id", type: "uint256" }],
    name: "ProposalCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "id", type: "uint256" },
      { indexed: false, internalType: "address", name: "proposer", type: "address" },
      { indexed: false, internalType: "address[]", name: "targets", type: "address[]" },
      { indexed: false, internalType: "uint256[]", name: "values", type: "uint256[]" },
      { indexed: false, internalType: "string[]", name: "signatures", type: "string[]" },
      { indexed: false, internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { indexed: false, internalType: "uint256", name: "startBlock", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "endBlock", type: "uint256" },
      { indexed: false, internalType: "string", name: "description", type: "string" },
    ],
    name: "ProposalCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "uint256", name: "id", type: "uint256" }],
    name: "ProposalCreatedOnTimelockV1",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "id", type: "uint256" },
      { indexed: false, internalType: "address", name: "proposer", type: "address" },
      { indexed: false, internalType: "address[]", name: "targets", type: "address[]" },
      { indexed: false, internalType: "uint256[]", name: "values", type: "uint256[]" },
      { indexed: false, internalType: "string[]", name: "signatures", type: "string[]" },
      { indexed: false, internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { indexed: false, internalType: "uint256", name: "startBlock", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "endBlock", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "proposalThreshold", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "quorumVotes", type: "uint256" },
      { indexed: false, internalType: "string", name: "description", type: "string" },
    ],
    name: "ProposalCreatedWithRequirements",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "id", type: "uint256" },
      { indexed: false, internalType: "address[]", name: "signers", type: "address[]" },
      { indexed: false, internalType: "uint256", name: "updatePeriodEndBlock", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "proposalThreshold", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "quorumVotes", type: "uint256" },
      { indexed: true, internalType: "uint32", name: "clientId", type: "uint32" },
    ],
    name: "ProposalCreatedWithRequirements",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "id", type: "uint256" },
      { indexed: true, internalType: "address", name: "proposer", type: "address" },
      { indexed: false, internalType: "string", name: "description", type: "string" },
      { indexed: false, internalType: "string", name: "updateMessage", type: "string" },
    ],
    name: "ProposalDescriptionUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "uint256", name: "id", type: "uint256" }],
    name: "ProposalExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "id", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "objectionPeriodEndBlock", type: "uint256" },
    ],
    name: "ProposalObjectionPeriodSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "id", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "eta", type: "uint256" },
    ],
    name: "ProposalQueued",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "oldProposalThresholdBPS", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "newProposalThresholdBPS", type: "uint256" },
    ],
    name: "ProposalThresholdBPSSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "id", type: "uint256" },
      { indexed: true, internalType: "address", name: "proposer", type: "address" },
      { indexed: false, internalType: "address[]", name: "targets", type: "address[]" },
      { indexed: false, internalType: "uint256[]", name: "values", type: "uint256[]" },
      { indexed: false, internalType: "string[]", name: "signatures", type: "string[]" },
      { indexed: false, internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { indexed: false, internalType: "string", name: "updateMessage", type: "string" },
    ],
    name: "ProposalTransactionsUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint32", name: "oldProposalUpdatablePeriodInBlocks", type: "uint32" },
      { indexed: false, internalType: "uint32", name: "newProposalUpdatablePeriodInBlocks", type: "uint32" },
    ],
    name: "ProposalUpdatablePeriodSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "id", type: "uint256" },
      { indexed: true, internalType: "address", name: "proposer", type: "address" },
      { indexed: false, internalType: "address[]", name: "targets", type: "address[]" },
      { indexed: false, internalType: "uint256[]", name: "values", type: "uint256[]" },
      { indexed: false, internalType: "string[]", name: "signatures", type: "string[]" },
      { indexed: false, internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { indexed: false, internalType: "string", name: "description", type: "string" },
      { indexed: false, internalType: "string", name: "updateMessage", type: "string" },
    ],
    name: "ProposalUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "uint256", name: "id", type: "uint256" }],
    name: "ProposalVetoed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint32", name: "oldQuorumCoefficient", type: "uint32" },
      { indexed: false, internalType: "uint32", name: "newQuorumCoefficient", type: "uint32" },
    ],
    name: "QuorumCoefficientSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "oldQuorumVotesBPS", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "newQuorumVotesBPS", type: "uint256" },
    ],
    name: "QuorumVotesBPSSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "voter", type: "address" },
      { indexed: false, internalType: "uint256", name: "refundAmount", type: "uint256" },
      { indexed: false, internalType: "bool", name: "refundSent", type: "bool" },
    ],
    name: "RefundableVote",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "signer", type: "address" },
      { indexed: false, internalType: "bytes", name: "sig", type: "bytes" },
    ],
    name: "SignatureCancelled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "timelock", type: "address" },
      { indexed: false, internalType: "address", name: "timelockV1", type: "address" },
      { indexed: false, internalType: "address", name: "admin", type: "address" },
    ],
    name: "TimelocksAndAdminSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "voter", type: "address" },
      { indexed: false, internalType: "uint256", name: "proposalId", type: "uint256" },
      { indexed: false, internalType: "uint8", name: "support", type: "uint8" },
      { indexed: false, internalType: "uint256", name: "votes", type: "uint256" },
      { indexed: false, internalType: "string", name: "reason", type: "string" },
    ],
    name: "VoteCast",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "voter", type: "address" },
      { indexed: true, internalType: "uint256", name: "proposalId", type: "uint256" },
      { indexed: true, internalType: "uint32", name: "clientId", type: "uint32" },
    ],
    name: "VoteCastWithClientId",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "oldVotingDelay", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "newVotingDelay", type: "uint256" },
    ],
    name: "VotingDelaySet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "oldVotingPeriod", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "newVotingPeriod", type: "uint256" },
    ],
    name: "VotingPeriodSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
      { indexed: false, internalType: "bool", name: "sent", type: "bool" },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint32", name: "forkId", type: "uint32" },
      { indexed: true, internalType: "address", name: "owner", type: "address" },
      { indexed: false, internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
    ],
    name: "WithdrawFromForkEscrow",
    type: "event",
  },
  { stateMutability: "payable", type: "fallback" },
  {
    inputs: [],
    name: "MAX_PROPOSAL_THRESHOLD_BPS",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_VOTING_DELAY",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_VOTING_PERIOD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_PROPOSAL_THRESHOLD_BPS",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_VOTING_DELAY",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_VOTING_PERIOD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "adjustedTotalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "admin",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "proposalId", type: "uint256" }],
    name: "cancel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes", name: "sig", type: "bytes" }],
    name: "cancelSig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "uint8", name: "support", type: "uint8" },
    ],
    name: "castRefundableVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "uint8", name: "support", type: "uint8" },
      { internalType: "uint32", name: "clientId", type: "uint32" },
    ],
    name: "castRefundableVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "uint8", name: "support", type: "uint8" },
      { internalType: "string", name: "reason", type: "string" },
    ],
    name: "castRefundableVoteWithReason",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "uint8", name: "support", type: "uint8" },
      { internalType: "string", name: "reason", type: "string" },
      { internalType: "uint32", name: "clientId", type: "uint32" },
    ],
    name: "castRefundableVoteWithReason",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "uint8", name: "support", type: "uint8" },
    ],
    name: "castVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "uint8", name: "support", type: "uint8" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" },
    ],
    name: "castVoteBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "uint8", name: "support", type: "uint8" },
      { internalType: "string", name: "reason", type: "string" },
    ],
    name: "castVoteWithReason",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "againstVotes", type: "uint256" },
      { internalType: "uint256", name: "adjustedTotalSupply_", type: "uint256" },
      {
        components: [
          { internalType: "uint16", name: "minQuorumVotesBPS", type: "uint16" },
          { internalType: "uint16", name: "maxQuorumVotesBPS", type: "uint16" },
          { internalType: "uint32", name: "quorumCoefficient", type: "uint32" },
        ],
        internalType: "struct NounsDAOTypes.DynamicQuorumParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "dynamicQuorumVotes",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "erc20TokensToIncludeInFork",
    outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
      { internalType: "uint256[]", name: "proposalIds", type: "uint256[]" },
      { internalType: "string", name: "reason", type: "string" },
    ],
    name: "escrowToFork",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "proposalId", type: "uint256" }],
    name: "execute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "executeFork",
    outputs: [
      { internalType: "address", name: "forkTreasury", type: "address" },
      { internalType: "address", name: "forkToken", type: "address" },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "forkDAODeployer",
    outputs: [{ internalType: "contract IForkDAODeployer", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "forkEndTimestamp",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "forkEscrow",
    outputs: [{ internalType: "contract INounsDAOForkEscrow", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "forkPeriod",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "forkThreshold",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "forkThresholdBPS",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "proposalId", type: "uint256" }],
    name: "getActions",
    outputs: [
      { internalType: "address[]", name: "targets", type: "address[]" },
      { internalType: "uint256[]", name: "values", type: "uint256[]" },
      { internalType: "string[]", name: "signatures", type: "string[]" },
      { internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "blockNumber_", type: "uint256" }],
    name: "getDynamicQuorumParamsAt",
    outputs: [
      {
        components: [
          { internalType: "uint16", name: "minQuorumVotesBPS", type: "uint16" },
          { internalType: "uint16", name: "maxQuorumVotesBPS", type: "uint16" },
          { internalType: "uint32", name: "quorumCoefficient", type: "uint32" },
        ],
        internalType: "struct NounsDAOTypes.DynamicQuorumParams",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "address", name: "voter", type: "address" },
    ],
    name: "getReceipt",
    outputs: [
      {
        components: [
          { internalType: "bool", name: "hasVoted", type: "bool" },
          { internalType: "uint8", name: "support", type: "uint8" },
          { internalType: "uint96", name: "votes", type: "uint96" },
        ],
        internalType: "struct NounsDAOTypes.Receipt",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "timelock_", type: "address" },
      { internalType: "address", name: "nouns_", type: "address" },
      { internalType: "address", name: "forkEscrow_", type: "address" },
      { internalType: "address", name: "forkDAODeployer_", type: "address" },
      { internalType: "address", name: "vetoer_", type: "address" },
      {
        components: [
          { internalType: "uint256", name: "votingPeriod", type: "uint256" },
          { internalType: "uint256", name: "votingDelay", type: "uint256" },
          { internalType: "uint256", name: "proposalThresholdBPS", type: "uint256" },
          { internalType: "uint32", name: "lastMinuteWindowInBlocks", type: "uint32" },
          { internalType: "uint32", name: "objectionPeriodDurationInBlocks", type: "uint32" },
          { internalType: "uint32", name: "proposalUpdatablePeriodInBlocks", type: "uint32" },
        ],
        internalType: "struct NounsDAOTypes.NounsDAOParams",
        name: "daoParams_",
        type: "tuple",
      },
      {
        components: [
          { internalType: "uint16", name: "minQuorumVotesBPS", type: "uint16" },
          { internalType: "uint16", name: "maxQuorumVotesBPS", type: "uint16" },
          { internalType: "uint32", name: "quorumCoefficient", type: "uint32" },
        ],
        internalType: "struct NounsDAOTypes.DynamicQuorumParams",
        name: "dynamicQuorumParams_",
        type: "tuple",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
      { internalType: "uint256[]", name: "proposalIds", type: "uint256[]" },
      { internalType: "string", name: "reason", type: "string" },
    ],
    name: "joinFork",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lastMinuteWindowInBlocks",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "latestProposalIds",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxQuorumVotes",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minQuorumVotes",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nouns",
    outputs: [{ internalType: "contract NounsTokenLike", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "numTokensInForkEscrow",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "objectionPeriodDurationInBlocks",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingVetoer",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalCount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "firstProposalId", type: "uint256" },
      { internalType: "uint256", name: "lastProposalId", type: "uint256" },
      { internalType: "uint16", name: "proposalEligibilityQuorumBps", type: "uint16" },
      { internalType: "bool", name: "excludeCanceled", type: "bool" },
      { internalType: "bool", name: "requireVotingEnded", type: "bool" },
      { internalType: "uint32[]", name: "votingClientIds", type: "uint32[]" },
    ],
    name: "proposalDataForRewards",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "endBlock", type: "uint256" },
          { internalType: "uint256", name: "objectionPeriodEndBlock", type: "uint256" },
          { internalType: "uint256", name: "forVotes", type: "uint256" },
          { internalType: "uint256", name: "againstVotes", type: "uint256" },
          { internalType: "uint256", name: "abstainVotes", type: "uint256" },
          { internalType: "uint256", name: "totalSupply", type: "uint256" },
          { internalType: "uint256", name: "creationTimestamp", type: "uint256" },
          { internalType: "uint32", name: "clientId", type: "uint32" },
          {
            components: [
              { internalType: "uint32", name: "votes", type: "uint32" },
              { internalType: "uint32", name: "txs", type: "uint32" },
            ],
            internalType: "struct NounsDAOTypes.ClientVoteData[]",
            name: "voteData",
            type: "tuple[]",
          },
        ],
        internalType: "struct NounsDAOTypes.ProposalForRewards[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalMaxOperations",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalThreshold",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalThresholdBPS",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalUpdatablePeriodInBlocks",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "proposalId", type: "uint256" }],
    name: "proposals",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "address", name: "proposer", type: "address" },
          { internalType: "uint256", name: "proposalThreshold", type: "uint256" },
          { internalType: "uint256", name: "quorumVotes", type: "uint256" },
          { internalType: "uint256", name: "eta", type: "uint256" },
          { internalType: "uint256", name: "startBlock", type: "uint256" },
          { internalType: "uint256", name: "endBlock", type: "uint256" },
          { internalType: "uint256", name: "forVotes", type: "uint256" },
          { internalType: "uint256", name: "againstVotes", type: "uint256" },
          { internalType: "uint256", name: "abstainVotes", type: "uint256" },
          { internalType: "bool", name: "canceled", type: "bool" },
          { internalType: "bool", name: "vetoed", type: "bool" },
          { internalType: "bool", name: "executed", type: "bool" },
          { internalType: "uint256", name: "totalSupply", type: "uint256" },
          { internalType: "uint256", name: "creationBlock", type: "uint256" },
        ],
        internalType: "struct NounsDAOTypes.ProposalCondensedV2",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "proposalId", type: "uint256" }],
    name: "proposalsV3",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "address", name: "proposer", type: "address" },
          { internalType: "uint256", name: "proposalThreshold", type: "uint256" },
          { internalType: "uint256", name: "quorumVotes", type: "uint256" },
          { internalType: "uint256", name: "eta", type: "uint256" },
          { internalType: "uint256", name: "startBlock", type: "uint256" },
          { internalType: "uint256", name: "endBlock", type: "uint256" },
          { internalType: "uint256", name: "forVotes", type: "uint256" },
          { internalType: "uint256", name: "againstVotes", type: "uint256" },
          { internalType: "uint256", name: "abstainVotes", type: "uint256" },
          { internalType: "bool", name: "canceled", type: "bool" },
          { internalType: "bool", name: "vetoed", type: "bool" },
          { internalType: "bool", name: "executed", type: "bool" },
          { internalType: "uint256", name: "totalSupply", type: "uint256" },
          { internalType: "uint256", name: "creationBlock", type: "uint256" },
          { internalType: "address[]", name: "signers", type: "address[]" },
          { internalType: "uint256", name: "updatePeriodEndBlock", type: "uint256" },
          { internalType: "uint256", name: "objectionPeriodEndBlock", type: "uint256" },
          { internalType: "bool", name: "executeOnTimelockV1", type: "bool" },
        ],
        internalType: "struct NounsDAOTypes.ProposalCondensedV3",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "targets", type: "address[]" },
      { internalType: "uint256[]", name: "values", type: "uint256[]" },
      { internalType: "string[]", name: "signatures", type: "string[]" },
      { internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { internalType: "string", name: "description", type: "string" },
      { internalType: "uint32", name: "clientId", type: "uint32" },
    ],
    name: "propose",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "targets", type: "address[]" },
      { internalType: "uint256[]", name: "values", type: "uint256[]" },
      { internalType: "string[]", name: "signatures", type: "string[]" },
      { internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { internalType: "string", name: "description", type: "string" },
    ],
    name: "propose",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "bytes", name: "sig", type: "bytes" },
          { internalType: "address", name: "signer", type: "address" },
          { internalType: "uint256", name: "expirationTimestamp", type: "uint256" },
        ],
        internalType: "struct NounsDAOTypes.ProposerSignature[]",
        name: "proposerSignatures",
        type: "tuple[]",
      },
      { internalType: "address[]", name: "targets", type: "address[]" },
      { internalType: "uint256[]", name: "values", type: "uint256[]" },
      { internalType: "string[]", name: "signatures", type: "string[]" },
      { internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { internalType: "string", name: "description", type: "string" },
    ],
    name: "proposeBySigs",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "bytes", name: "sig", type: "bytes" },
          { internalType: "address", name: "signer", type: "address" },
          { internalType: "uint256", name: "expirationTimestamp", type: "uint256" },
        ],
        internalType: "struct NounsDAOTypes.ProposerSignature[]",
        name: "proposerSignatures",
        type: "tuple[]",
      },
      { internalType: "address[]", name: "targets", type: "address[]" },
      { internalType: "uint256[]", name: "values", type: "uint256[]" },
      { internalType: "string[]", name: "signatures", type: "string[]" },
      { internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { internalType: "string", name: "description", type: "string" },
      { internalType: "uint32", name: "clientId", type: "uint32" },
    ],
    name: "proposeBySigs",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "targets", type: "address[]" },
      { internalType: "uint256[]", name: "values", type: "uint256[]" },
      { internalType: "string[]", name: "signatures", type: "string[]" },
      { internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { internalType: "string", name: "description", type: "string" },
    ],
    name: "proposeOnTimelockV1",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "targets", type: "address[]" },
      { internalType: "uint256[]", name: "values", type: "uint256[]" },
      { internalType: "string[]", name: "signatures", type: "string[]" },
      { internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { internalType: "string", name: "description", type: "string" },
      { internalType: "uint32", name: "clientId", type: "uint32" },
    ],
    name: "proposeOnTimelockV1",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "proposalId", type: "uint256" }],
    name: "queue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "quorumParamsCheckpoints",
    outputs: [
      {
        components: [
          { internalType: "uint32", name: "fromBlock", type: "uint32" },
          {
            components: [
              { internalType: "uint16", name: "minQuorumVotesBPS", type: "uint16" },
              { internalType: "uint16", name: "maxQuorumVotesBPS", type: "uint16" },
              { internalType: "uint32", name: "quorumCoefficient", type: "uint32" },
            ],
            internalType: "struct NounsDAOTypes.DynamicQuorumParams",
            name: "params",
            type: "tuple",
          },
        ],
        internalType: "struct NounsDAOTypes.DynamicQuorumParamsCheckpoint[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "index", type: "uint256" }],
    name: "quorumParamsCheckpoints",
    outputs: [
      {
        components: [
          { internalType: "uint32", name: "fromBlock", type: "uint32" },
          {
            components: [
              { internalType: "uint16", name: "minQuorumVotesBPS", type: "uint16" },
              { internalType: "uint16", name: "maxQuorumVotesBPS", type: "uint16" },
              { internalType: "uint32", name: "quorumCoefficient", type: "uint32" },
            ],
            internalType: "struct NounsDAOTypes.DynamicQuorumParams",
            name: "params",
            type: "tuple",
          },
        ],
        internalType: "struct NounsDAOTypes.DynamicQuorumParamsCheckpoint",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "proposalId", type: "uint256" }],
    name: "quorumVotes",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quorumVotesBPS",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "proposalId", type: "uint256" }],
    name: "state",
    outputs: [{ internalType: "enum NounsDAOTypes.ProposalState", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timelock",
    outputs: [{ internalType: "contract INounsDAOExecutor", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timelockV1",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "address[]", name: "targets", type: "address[]" },
      { internalType: "uint256[]", name: "values", type: "uint256[]" },
      { internalType: "string[]", name: "signatures", type: "string[]" },
      { internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { internalType: "string", name: "description", type: "string" },
      { internalType: "string", name: "updateMessage", type: "string" },
    ],
    name: "updateProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      {
        components: [
          { internalType: "bytes", name: "sig", type: "bytes" },
          { internalType: "address", name: "signer", type: "address" },
          { internalType: "uint256", name: "expirationTimestamp", type: "uint256" },
        ],
        internalType: "struct NounsDAOTypes.ProposerSignature[]",
        name: "proposerSignatures",
        type: "tuple[]",
      },
      { internalType: "address[]", name: "targets", type: "address[]" },
      { internalType: "uint256[]", name: "values", type: "uint256[]" },
      { internalType: "string[]", name: "signatures", type: "string[]" },
      { internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { internalType: "string", name: "description", type: "string" },
      { internalType: "string", name: "updateMessage", type: "string" },
    ],
    name: "updateProposalBySigs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "string", name: "description", type: "string" },
      { internalType: "string", name: "updateMessage", type: "string" },
    ],
    name: "updateProposalDescription",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "proposalId", type: "uint256" },
      { internalType: "address[]", name: "targets", type: "address[]" },
      { internalType: "uint256[]", name: "values", type: "uint256[]" },
      { internalType: "string[]", name: "signatures", type: "string[]" },
      { internalType: "bytes[]", name: "calldatas", type: "bytes[]" },
      { internalType: "string", name: "updateMessage", type: "string" },
    ],
    name: "updateProposalTransactions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "proposalId", type: "uint256" }],
    name: "veto",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vetoer",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "voteSnapshotBlockSwitchProposalId",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingDelay",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingPeriod",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
      { internalType: "address", name: "to", type: "address" },
    ],
    name: "withdrawDAONounsFromEscrowIncreasingTotalSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256[]", name: "tokenIds", type: "uint256[]" }],
    name: "withdrawDAONounsFromEscrowToTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256[]", name: "tokenIds", type: "uint256[]" }],
    name: "withdrawFromForkEscrow",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  { stateMutability: "payable", type: "receive" },
] as const;
